export default __webpack_public_path__ + "static/media/filepdf.95650409.svg";